import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, BookmarkPlus, PenSquare } from "lucide-react";
import { SectionHeader, ReaderActivityCard } from "@/components/site/primitives";
import { fadeUp, stagger } from "@/lib/motion";
import { READERS, SHELVES } from "@/data";

const actionIcon = { finished: CheckCircle2, shelved: BookmarkPlus, "scribbled on": PenSquare };

export default function ActivityFeed() {
  return (
    <section className="u-container mt-14 md:mt-20" data-testid="home-activity">
      <SectionHeader eyebrow="What's happening" title="Community Conversations" />
      <div className="mt-8 grid gap-10 lg:grid-cols-[1.4fr_1fr]">
        <motion.div variants={stagger} initial="hidden" animate="show" className="grid gap-4 sm:grid-cols-2">
          {READERS.map((reader, i) => (
            <motion.div key={reader.name} variants={fadeUp} custom={i}>
              <ReaderActivityCard reader={reader} />
            </motion.div>
          ))}
        </motion.div>

        <motion.div variants={fadeUp} initial="hidden" animate="show" custom={2} className="card-paper p-5">
          <p className="font-display text-lg font-semibold text-ink">Your activity</p>
          <ul className="mt-4 space-y-4">
            {SHELVES.activity.map((a, i) => {
              const Icon = actionIcon[a.did] || CheckCircle2;
              return (
                <li key={i} className="flex items-start gap-3 text-sm">
                  <span className="mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-full bg-sage/30 text-[#4f6249] dark:bg-sage/15 dark:text-sage">
                    <Icon className="h-3.5 w-3.5" />
                  </span>
                  <p className="text-ink/80">
                    <span className="font-semibold text-ink">{a.who}</span> {a.did}{" "}
                    <span className="font-medium text-ink">{a.what}</span>
                  </p>
                </li>
              );
            })}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
